import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Login from './Login.js';
import Signup from './Signup';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';
import Chat from './pages/Chat.js';
import PasswordReset from './pages/PasswordReset.js';
import SuperAdmin from './pages/SuperAdmin.js';
import AppMenu from './components/AppMenu.js';
import Dashboard from './pages/Dashboard.js';
import Organizations from './pages/Organizations.js';
import Providers from './pages/Providers.js';
import ApiKeys from './pages/ApiKeys.js';
import DefaultApiKeys from './pages/DefaultApiKeys.js';
import Models from './pages/Models.js';
import Users from './pages/Users.js';
import OrganizationView from './pages/OrganizationView.js';
import Avatars from './pages/Avatar.jsx';
import Configurables from './pages/Configurables.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <Router>
      <AuthProvider>
     
        <Routes>
       
          <Route path="/login" element={<Login />} />
          <Route path="/passwordReset/:userId" element={<PasswordReset />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/organization" element={<PrivateRoute><Organizations /></PrivateRoute>} />
          <Route path="/organization/:orgId" element={<PrivateRoute><OrganizationView /></PrivateRoute>} />
          <Route path="/provider" element={<PrivateRoute><Providers /></PrivateRoute>} />
          <Route path="/avatar" element={<PrivateRoute><Avatars /></PrivateRoute>} />
          {/* <Route path="/apikeys" element={<PrivateRoute><ApiKeys /></PrivateRoute>} /> */}
          <Route path="/api-keys" element={<PrivateRoute><DefaultApiKeys /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
          <Route path="/model" element={<PrivateRoute><Models /></PrivateRoute>} />
          <Route path="/configurables" element={<PrivateRoute><Configurables /></PrivateRoute>} />
          <Route path="/chat" element={<PrivateRoute><Chat /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute requiredRole="admin"><SuperAdmin /></PrivateRoute>} />
        </Routes>

      </AuthProvider>
    </Router>

  </React.StrictMode>
);
